import TextFieldMaterial from '@mui/material/TextField';
import PropTypes from 'prop-types';

const TextField = ({
  error = false,
  fullWidth = true,
  helperText = ' ',
  inputProps = {},
  label,
  margin = 'normal',
  slotProps = {},
  ...other
}) => {
  return (
    <TextFieldMaterial
      error={error}
      fullWidth={fullWidth}
      helperText={helperText}
      label={label}
      margin={margin}
      slotProps={{ ...slotProps, htmlInput: { ...inputProps, ...slotProps.htmlInput } }}
      variant="outlined"
      {...other}
    />
  );
};

TextField.propTypes = {
  error: PropTypes.bool,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
  inputProps: PropTypes.shape({}),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),
  slotProps: PropTypes.shape({}),
};

export default TextField;
